//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProductToSearch"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"

//
import InventoryDetailHeaders from "./headers"

//
export default ({ g_branch_office_id, g_branch_office_id_selected, wh_warehouse_trigger }) => [
    {
        name: "g_warehouseman_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "full_name",
            itemValue: "id",
            label: "Responsable",
            loadingText: "Cargando empleados...",
            model: UserModel,
            noDataText: "Sin empleados.",
            noObject: true,
            readonly: true,
            rules: [ required ],
        },
    },
    {
        name: "wh_warehouse_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Bodega",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
            rules: [ required ],
        },
        trigger: wh_warehouse_trigger,
    },
    {
        name: "g_supervisor_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "full_name",
            itemValue: "id",
            label: "Supervisor",
            loadingText: "Cargando empleados...",
            model: UserModel,
            noDataText: "Sin empleados.",
            noObject: true,
            readonly: true,
            rules: [ required ],
        },
    },
    {
        name: "g_state_state",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Estado",
            readonly: true,
        },
    },
    {
        name: "created_at",
        type: "date-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Creado",
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: "updated_at",
        type: "date-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Modificado",
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: "inventory_date",
        type: "date-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Confirmado",
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: "wh_selected_products",
        type: "data-table-model",
        flex: {
            "pt-0": true,
            "xs12": true,
            "d-grid": true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers: InventoryDetailHeaders,
            noActions: true,
            noDataText: "Sin productos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                attachParams: {
                    stock_branch_office_id: g_branch_office_id,
                },
                filters: ProductFilters({}).slice(0, -1).filter( ( e, i ) => i !== 3 ),
                headers: JSON.parse(JSON.stringify(ProductHeaders)).filter((e,i)=> i!==5).map(e => {
                    if(e.value === 'stock_total') {
                        e.value = 'stock_branch_office'
                    }
                    return e
                }),
                noPagination: false,
                mapper: row => {
                    //
                    row[ "g_branch_office_id" ] = g_branch_office_id_selected;
                    row[ "expected_amount" ]    = row.stock_total || row.expected_amount || 0,
                    row[ "wh_product_id" ]      = row.id
                    //
                    return row
                },
                submitText: "confirmar selección",
                service: ProductModel,
            },
            rowsPerPage: 50,
            rules: [ required ],
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: "Lista de productos incluidos en el inventario",
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
        },
    },
    {
        name: "description",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Descripción",
            rules: [ required ],
        },
    },
]